import React, { useEffect, useState } from "react";
import axios from "axios";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { routeConstants } from "navigation/routeConstants";
import { ReactComponent as LeftArrowIcon } from "common/assets/icons/chevron-left.svg";
import { useNavigate, useParams } from "react-router-dom";
import { serviceConfig } from "configs";
import FileItem from "common/FileItem/FolderItem";
import FileUpload from "common/FileUpload/FileUpload";
import { Button } from "common/Button/Button";
import { ReactComponent as PlusIcon } from "common/assets/icons/plus.svg";
import Modal from "common/Modal/Modal";

const ArchieveDetailPage: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const { id } = useParams<{ id: string }>();
	const [files, setFiles] = useState<any[]>([]);
	const [addedUserId, setAddedUserId] = useState<string | null>(null);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [filesData, setFilesData] = useState<any>([]);

	const userString = localStorage.getItem("user");
	const user = userString ? JSON.parse(userString) : null;

	const userId = user ? user?.user._id : ""; // Replace with actual user ID
	const userTypeId = user ? user?.user.userTypeId?._id : null;
	const numericUserTypeId = parseInt(userTypeId);

	useEffect(() => {
		const fetchFiles = async () => {
			try {
				const response = await axios.get(
					`${serviceConfig.apiUrl}/folders/${id}/files`
				);
				setFiles(response.data.files);
				setAddedUserId(response.data.addedUserId);
			} catch (error) {
				console.error("Error fetching files:", error);
			}
		};

		fetchFiles();
	}, [id]);

	const handleBackClick = () => {
		navigate(-1);
	};
	const handleDeleteFile = async (fileName: string) => {
		try {
			const response = await axios.post(
				`${serviceConfig.apiUrl}/folders/files/delete`,
				{
					folderName: id, // Assuming 'id' is your folder ID
					fileName: fileName,
				}
			);

			if (response.status === 200) {
				setFiles((prevFiles) =>
					prevFiles.filter((file) => file.name !== fileName)
				);
			}
		} catch (error) {
			console.error("Error deleting file:", error);
		}
	};

	const handleDownloadFile = (fileName: string) => {
		window.open(`${serviceConfig.apiUrl}/download?path=${fileName}`, "_blank");
	};

	const openModal = () => setIsModalOpen(true);
	const closeModal = () => setIsModalOpen(false);

	const breadcrumbItems = [
		{ label: "Faýl arhiwi", path: routeConstants.root.route },
		{ label: "Arhiw", path: routeConstants.archieve.route },
		{ label: `${id}` },
	];

	const handleFileChange = (e: any) => {
		if (e.target.files) {
			const filesArray = Array.from(e.target.files);
			setFilesData(filesArray);
		}
	};

	const handleAddFile = async () => {
		const formData = new FormData();

		filesData.forEach((file: any) => {
			formData.append("files", file, file.name);
		});

		try {
			// Make sure to update the URL to the correct endpoint for posting files to a folder
			const response = await axios.post(
				`${serviceConfig.apiUrl}/folders/${id}/files`,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				}
			);

			if (response.status === 201) {
				closeModal();
				window.location.reload(); // Reload the page to update the list of files
				setFilesData([]); // Reset the files data
			} else {
				console.error("Failed to add files:", response.data.message);
			}
		} catch (error) {
			console.error("Error adding files:", error);
		}
	};

	return (
		<>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 pt-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid grid-cols-maxTwo place-content-between place-items-center">
					<div
						className="p-[10px] rounded-md bg-lowOpacity w-max h-max cursor-pointer"
						onClick={handleBackClick}
					>
						<LeftArrowIcon className="stroke-mainColor" />
					</div>
					<Button
						appearance="main"
						paddingY="py-2"
						className="h-max"
						icon={<PlusIcon className="stroke-white" />}
						onClick={openModal}
					>
						Faýllary Ýüklemek
					</Button>
				</div>
				<div className="grid gap-6 lg:grid-cols-maxEight TwoXl:grid-cols-maxNine">
					{files.map((file, idx) => (
						<FileItem
							key={idx}
							name={file.name.split("_")[0]}
							size={file.size}
							type={file.type}
							onDelete={() => handleDeleteFile(file.name)}
							onDownload={() => handleDownloadFile(file.path)}
							notDeletable={addedUserId !== userId} // Compare the IDs to control deletion ability
						/>
					))}
				</div>

				<Modal
					isOpen={isModalOpen}
					onClose={closeModal}
					title="Faýllary Ýüklemek"
					width="w-[600px]"
				>
					<div className="grid grid-flow-row grid-cols-1 gap-6 auto-rows-max">
						<FileUpload
							files={filesData}
							onChange={handleFileChange}
							label="Ýüklenilýän faýllar"
						/>

						<Button
							appearance="main"
							className="place-self-end"
							paddingX="px-5"
							paddingY="py-[10px]"
							onClick={handleAddFile}
						>
							Ýüklemek
						</Button>
					</div>
				</Modal>
			</div>
		</>
	);
};

export default ArchieveDetailPage;
